<div class="flex flex-1 flex-row items-center gap-1">
  <dx-form
    [formData]="formData"
    [readOnly]="readOnly"
    (onFieldDataChanged)="onFieldDataChanged($event)"
    class="flex-1"
  >
    <dxi-item
      dataField="value"
      editorType="dxSelectBox"
      [editorOptions]="editorOptions"
      [label]="{
        text: item.config?.title,
        location: 'top',
        showColon: false,
        visible: !!item.config?.title
      }"
    ></dxi-item>
  </dx-form>
  @if (item.config?.quickview) {
    <div class="flex flex-row items-center justify-center">
      <i class="fa-light fa-eye opacity-50"></i>
    </div>
  }
</div>
